import React, { useContext, useMemo, useState } from 'react';
import DeleteTitles from '../composed-components/Actions/Delete/DeleteTitles';
import ExcludeTitles from '../composed-components/Actions/Exclude/ExcludeTitles';
import SendToCRM from '../composed-components/Actions/ToCRM/SendToCRM';
import BlockAuthorTitle from '../composed-components/Actions/BlockAuthor/BlockAuthorTitle';
import MuteAuthorTitles from '../composed-components/Actions/MuteAuthor/MuteAuthorTitles';
import UnmuteAuthorTitles from '../composed-components/Actions/UnmuteAuthor/UnmuteAuthorTitles';
import WatchlistTitles from '../composed-components/Actions/Watch/WatchlistTitles';
import ContactedTitles from '../composed-components/Actions/ToContacted/ContactedTitles';
import PendingExclusionTitles from '../composed-components/Actions/ToPendingExclusion/PendingExclusionTitles';
import PodiumTitles from '../composed-components/Actions/ToPodiumTitle/PodiumTitles';
import ReturnTitles from '../composed-components/Actions/Return/ReturnTitles';

const ActionsContext = React.createContext({
  setAction: values => console.log(values),
  source: '/bookstat',
  isActionLoading: false,
  setActionLoading: (value: boolean) => console.log(value),
  isRefreshed: false,
  setIsRefreshed: (value: boolean) => console.log(value)
});

export const ACTIONS = {
  delete: 'delete',
  return: 'return',
  watch: 'watch',
  exclude: 'exclude',
  toCRM: 'toCRM',
  blockAuthor: 'blockAuthor',
  muteAuthor: 'muteAuthor',
  unmuteAuthor: 'unmuteAuthor',
  contacted: 'contacted',
  pendingExclusion: 'pendingExclusion',
  podiumTitle: 'podiumTitle',
  pinTitle: 'pinTitle',
  unpinTitle: 'unpinTitle'
};

const defaultActionObject = {
  type: null,
  book: { ASIN: '', id: '', Title: '', Author: '', work_id: 0 },
  id: ''
};

export const ActionsProvider = ({ children, source }) => {
  const [action, setAction] = useState(defaultActionObject);
  const [actionLoading, setActionLoading] = useState(false);
  const [isRefreshed, setIsRefreshed] = useState(false);

  const contextValue = useMemo(() => ({
    setAction,
    source,
    isActionLoading: actionLoading,
    setActionLoading,
    isRefreshed,
    setIsRefreshed
  }), [setAction, source, actionLoading, setActionLoading, isRefreshed, setIsRefreshed]);

  return (
    <ActionsContext.Provider value={contextValue}>
      <DeleteTitles
        book={action?.book}
        id={action?.id}
        modal={action?.type === ACTIONS.delete}
        closeModal={() => setAction(defaultActionObject)}
      />
      <ExcludeTitles
        book={action?.book}
        id={action.id}
        modal={action?.type === ACTIONS.exclude}
        toggleModal={() => setAction(defaultActionObject)}
      />
      <SendToCRM
        book={action?.book}
        id={action.id}
        modal={action?.type === ACTIONS.toCRM}
        toggleModal={() => setAction(defaultActionObject)}
      />
      <BlockAuthorTitle
        book={action?.book}
        id={action.id}
        modal={action?.type === ACTIONS.blockAuthor}
        closeModal={() => setAction(defaultActionObject)}
      />
      <MuteAuthorTitles
        book={action?.book}
        id={action.id}
        modal={action?.type === ACTIONS.muteAuthor}
        toggleModal={() => setAction(defaultActionObject)}
      />
      <UnmuteAuthorTitles
        book={action?.book}
        id={action.id}
        modal={action?.type === ACTIONS.unmuteAuthor}
        toggleModal={() => setAction(defaultActionObject)}
      />
      <WatchlistTitles
        book={action?.book}
        id={action.id}
        modal={action?.type === ACTIONS.watch}
        toggleModal={() => setAction(defaultActionObject)}
      />
      <ContactedTitles
        book={action?.book}
        id={action.id}
        modal={action?.type === ACTIONS.contacted}
        toggleModal={() => setAction(defaultActionObject)}
      />
      <PendingExclusionTitles
        book={action?.book}
        id={action.id}
        modal={action?.type === ACTIONS.pendingExclusion}
        toggleModal={() => setAction(defaultActionObject)}
      />
      <PodiumTitles
        book={action?.book}
        id={action.id}
        modal={action?.type === ACTIONS.podiumTitle}
        toggleModal={() => setAction(defaultActionObject)}
      />
      <ReturnTitles
        book={action?.book}
        id={action.id}
        modal={action?.type === ACTIONS.return}
        toggleModal={() => setAction(defaultActionObject)}
      />
      {children}
    </ActionsContext.Provider>
  );
};

export const ActionsConsumer = ActionsContext.Consumer;

export const useActions = () => {
  const context = useContext(ActionsContext);

  return context;
};

export default ActionsContext;